export const URL_PATTERN = /((?:https?:\/\/|www\.)[^\s<]+)/gi;

const TRAILING_PUNCTUATION = new Set([".", ",", "!", "?", ";", ":"]);

function countChar(text, targetChar) {
  return Array.from(`${text || ""}`).filter((char) => char === targetChar)
    .length;
}

export function trimTrailingUrlCharacters(rawUrl) {
  let url = `${rawUrl || ""}`;
  let trailingText = "";

  while (url) {
    const lastChar = url.at(-1);

    if (TRAILING_PUNCTUATION.has(lastChar)) {
      trailingText = `${lastChar}${trailingText}`;
      url = url.slice(0, -1);
      continue;
    }

    if (lastChar === ")" && countChar(url, "(") < countChar(url, ")")) {
      trailingText = `${lastChar}${trailingText}`;
      url = url.slice(0, -1);
      continue;
    }

    if (lastChar === "]" && countChar(url, "[") < countChar(url, "]")) {
      trailingText = `${lastChar}${trailingText}`;
      url = url.slice(0, -1);
      continue;
    }

    if (lastChar === "}" && countChar(url, "{") < countChar(url, "}")) {
      trailingText = `${lastChar}${trailingText}`;
      url = url.slice(0, -1);
      continue;
    }

    break;
  }

  return { url, trailingText };
}

export function normalizeUrl(url) {
  if (!url) return "";
  return url.startsWith("www.") ? `https://${url}` : url;
}
